import {fromJS} from 'immutable';
import instance from '../../request/http';

// init data
const defaultState = fromJS({
    show: true,
    list:[]
});

// action key
const SHOW_ACTION_KEY = 'home/SHOW_ACTION_KEY';
const GET_LIST_KEY = 'home/GET_LIST_KEY';
// action
export const showAction = (value) => ({ type: SHOW_ACTION_KEY,value });
export const getList = () => { 
    return (dispath)=>{
        //异步action
        instance.get('/api/list.json').then((res)=>{
            const value = fromJS(res.data)
            dispath({type:GET_LIST_KEY,value})
        });
    }
};

// reducer
export const reducer = (state = defaultState, action) => {
    if (action.type === SHOW_ACTION_KEY) {
        return state.set('show',action.value);
    }else if(action.type === GET_LIST_KEY){
        return state.set('list',action.value);
    }
    return state;
}